import React, { useState, useEffect } from 'react';
import { Clock, Users, MapPin, Star, Check,ArrowLeft, Calendar } from 'lucide-react';
import { useNavigate ,useParams } from 'react-router-dom';
const ExcursionDetail = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate(); // ✅ define it here
  const { excursionId } = useParams(); // ✅ Récupère l'ID depuis l'URL
  // ✅ Mapping des IDs vers les sections
  const sectionMapping = {
    'vallee-ameln': 1,
    'Les-Gorges-d’Aït-Mansour': 2,
    'Aventure-Saharienne': 3,
    'Transfert-VIP': 4
  };
  // ✅ Définir la section en fonction de l'ID de l'URL
  const [currentSection, setCurrentSection] = useState(sectionMapping[excursionId] || 1);
  // ✅ Fonction pour changer de section avec navigation
  const handleSectionChange = (sectionNum) => {
    const idMap = {
      1: 'vallee-ameln',
      2: 'Les Gorges-d’Aït Mansour', 
      3: 'Aventure-Saharienne',
      4: 'Transfert-VIP'
    };
    navigate(`/excursions/${idMap[sectionNum]}`);
  };
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const section1Data = {
    title: 'Randonnées dans la vallée des Ameln',
    subtitle: 'Découvrez les Merveilles de la Vallée',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200',
    intro: 'Partez depuis le riad en direction du village d’Amsnat pour une belle immersion dans la vie locale. Cette randonnée comprend la visite d’une maison traditionnelle et la traversée des anciens villages de la vallée d’Ammeln, au milieu de paysages époustouflants où se mêlent montagnes, palmiers, arganiers et maisons en pierre',
    details: {
      duration: '3 heures',
      difficulty: 'Modéré',
      distance: '8 km',
      price: '600 DH'
    },
    program: [
      { time: '09:30', step: 'Départ du Riad Lina', icon: '' },
      { time: '10:00', step: 'Visite de la maison traditionnelle', icon: '' },
      { time: '13:00', step: 'Pique-nique', icon: '' },
      { time: '16:30', step: 'Retour au Riad', icon: '' }
    ],
    includes: ['Le guide accompagnateur', 'Le pique-nique en pleine nature', 'La visite de la maison traditionnelle'],
    equipment: ['Chaussures de randonnée', 'Chapeau', 'Appareil photo', 'Eau']
  };

  const section2Data = {
    title: 'Les Gorges d’Aït Mansour, les Roches Peintes et le Chapeau de Napoléon',
    subtitle: 'Art en Pleine Nature',
    image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=1200',
    description: 'La voiture vous conduira du riad en direction de l’oasis d’Aït Mansour, un trajet d’environ une heure.À votre arrivée, vous profiterez d’une magnifique balade à pied dans un cadre naturel exceptionnel. La durée de la marche sera à votre convenance.Vous continuerez ensuite à admirer les paysages grandioses de l’oasis d’Aït Mansour, entourée de montagnes imposantes aux couleurs fascinantes et à la géologie unique.Entre ces montagnes poussent différentes variétés d’arbres : palmiers, oliviers et amandiers. Au printemps, la floraison des amandiers offre un spectacle d’une beauté rare.',
    info: {
      duration: 'Journée complète',
      price: '1200-1500 MAD',
      type: 'Culturelle'
    },
    sites: [
      { name: 'En arrivant au village de Gdoura, vous profiterez d’une vue panoramique exceptionnelle sur l’oasis et le village, véritable témoignage du génie architectural berbère ', time: '10:00' },
      { name: 'Un déjeuner typique, préparé par les habitants du village, vous sera servi au cœur de la nature.', time: '12:30' },
      { name: 'Après le repas, vous poursuivrez votre excursion vers les roches colorées, célèbres pour leurs nuances bleutées et leurs formes surprenantes, avant de visiter la montagne du Chapeau de Napoléon', time: '13:00' },
      { name: 'Enfin, la journée se terminera par la visite de la médina, réputée pour son artisanat local : fabrication de chaussures, de produits cosmétiques et culinaires tels que l’huile d’argan et l’amlou.', time: '15:00' },
    ],
    services: ['Le transport touristique', 'Le déjeuner traditionnel']
  };

  const section3Data = {
    title: 'Excursions dans le désert depuis le Riad Lina – Tafraoute',
    subtitle: 'Aventure Saharienne',
    image: 'https://images.unsplash.com/photo-1570939274717-7eda259b50ed?w=1200',
    tagline: 'Partez à l’aventure vers le sud marocain avec nos circuits au départ du Riad Lina !',
    description: 'Découvrez les dunes de sable, la vallée du Drâa, les kasbahs historiques et vivez des expériences uniques : balade à dos de dromadaire, sandboard et bivouac sous les étoiles.',
    depart:'Depuis le Riad Lina – Tafraoute',
    circuits: [
      {
        duration: 'Circuit 3 jours / 2 nuits',
        title: 'Circuit Vallée Drâa',
        destinations: ['Vallée Drâa', 'Kasbah', 'Zagora'],
        highlights: ['écouverte de la vallée du Drâa.', 'visite de la Kasbah de Tamnougalte','nuit à Zagora'],
        price: 'Sur demande'
      },
      {
        duration: 'Circuit 4 jours / 3 nuits',
        title: 'Circuit Erg Chegaga',
        destinations: ['Erg Chegaga', 'Dunes'],
        highlights: ['Exploration des dunes de l’Erg Chegaga', 'nuit en bivouac dans le désert'],
        price: 'Sur demande',

      },
    ],
    experiences: [
      { icon: '🐪', name: 'Dromadaire' },
      { icon: '🏂', name: 'Sandboard' },
      { icon: '⛺', name: 'Bivouac' },
      { icon: '🍲', name: 'Cuisine berbère' }
    ]
  };

  const section4Data = {
    title: 'Service de navette Aéroport – Riad Lina',
    subtitle: 'Transfert VIP',
    image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1200',
    slogan: 'Profitez d’un transfert privé VIP entre l’aéroport et le Riad Lina à Tafraoute, dans le confort et la sérénité.Notre service de navette est disponible dans les deux sens :',
    titreroute: 'Itinéraires Disponibles',
    routes: [
      { from: 'Agadir Al Massira (AGA)', duration: '3-4h', distance: '170 km' },
      { from: 'Marrakech Menara (RAK)', duration: '5-6h', distance: '380 km' },
      // { from: 'Aéroport → Riad Lina ', duration: '3-4h', distance: '170 km' },
      // { from: 'Riad Lina → Aéroport', duration: '5-6h', distance: '380 km' }
    ],
    details4: {
      duration: 'Aéroport → Riad Lina',
      difficulty: 'Riad Lina → Aéroport',
     
    },
    advantages: [
      { icon: '🚗', title: 'Véhicule touristique VIP climatisé' },
      { icon: '👨‍✈️', title: 'Chauffeur professionnel et ponctuel' },
      { icon: '🎯', title: 'AAccueil personnalisé à l’aéroport' },
      { icon: '💼', title: 'Transfert confortable jusqu’à Tafraoute' }
    ]
  };

  const sections = [section1Data, section2Data, section3Data, section4Data];
  const currentData = sections[currentSection - 1];

  return (
    <div style={{ fontFamily: 'Georgia, serif', background: '#0a0a0a', color: '#fff', minHeight: '100vh' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;900&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }
        .fade-in { animation: fadeIn 0.8s ease-out; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        .luxury-card {
          background: linear-gradient(145deg, #1a1a1a, #0d0d0d);
          border: 1px solid rgba(212, 175, 55, 0.2);
          transition: all 0.3s;
        }
        .hover-gold:hover {
          border-color: rgba(212, 175, 55, 0.5);
          transform: translateY(-5px);
        }
      `}</style>

      <header style={{
        position: 'fixed', top: 0, width: '100%', zIndex: 1000,
        background: scrolled ? 'rgba(10, 10, 10, 0.95)' : 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(15px)', transition: 'all 0.3s',
        borderBottom: scrolled ? '1px solid rgba(212, 175, 55, 0.3)' : 'none'
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '20px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1 style={{ fontFamily: 'Playfair Display, serif', fontSize: '28px', color: '#d4af37', fontWeight: 900, letterSpacing: '3px' }}>
            RIAD LINA
          </h1>
          <button style={{
            background: 'linear-gradient(135deg, #d4af37, #f9e79f)',
            color: '#000', padding: '12px 30px', borderRadius: '30px',
            border: 'none', cursor: 'pointer', fontSize: '14px', fontWeight: 700
            
          }}
          onClick={() => navigate('/contact')}
          >
            Réserver
          </button>
        </div>
      </header>

      

      <section style={{
        position: 'relative', height: '70vh',
        backgroundImage: `url(${currentData.image})`,
        backgroundSize: 'cover', backgroundPosition: 'center'
      }} className="fade-in">
        <div style={{
          position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.8))'
        }} />
        <div style={{
          position: 'absolute', bottom: '40px', left: '50%', transform: 'translateX(-50%)',
          textAlign: 'center', width: '90%', maxWidth: '1000px'
        }}>
          <p style={{ fontSize: '16px', color: '#d4af37', marginBottom: '15px', letterSpacing: '3px', fontWeight: 600, textTransform: 'uppercase' }}>
            {currentData.subtitle}
          </p>
          <h1 style={{
            fontFamily: 'Playfair Display, serif', fontSize: 'clamp(28px, 5vw, 55px)',
            fontWeight: 900, marginBottom: '15px', textShadow: '2px 2px 20px rgba(0,0,0,0.8)', color: '#fff'
          }}>
            {currentData.title}
          </h1>
        </div>
        <button onClick={() => window.history.back()} style={{
          position: 'absolute',
          top: '100px',
          left: '30px',
          background: 'rgba(0, 0, 0, 0.7)',
          border: '2px solid #d4af37',
          color: '#d4af37',
          padding: '12px 24px',
          borderRadius: '30px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          fontSize: '16px',
          fontWeight: 600,
          transition: 'all 0.3s'
        }} onMouseEnter={e => { e.target.style.background = '#d4af37'; e.target.style.color = '#000'; }}
           onMouseLeave={e => { e.target.style.background = 'rgba(0, 0, 0, 0.7)'; e.target.style.color = '#d4af37'; }}>
          <ArrowLeft size={20} />
          Retour  
        </button>
      </section>

      {currentSection === 1 && (
        <section style={{ padding: '80px 30px', background: '#0f0f0f' }} className="fade-in">
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <p style={{ fontSize: '20px', lineHeight: '1.8', color: '#ccc', marginBottom: '50px', textAlign: 'center' }}>
              {section1Data.intro}
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '20px', marginBottom: '50px' }}>
              {Object.entries(section1Data.details).map(([key, value]) => (
                <div key={key} className="luxury-card hover-gold" style={{ padding: '25px', borderRadius: '15px', textAlign: 'center' }}>
                  <h4 style={{ color: '#d4af37', fontSize: '14px', marginBottom: '10px', textTransform: 'uppercase' }}>
                    {key}
                  </h4>
                  <p style={{ color: '#fff', fontSize: '20px', fontWeight: 700 }}>{value}</p>
                </div>
              ))}
            </div>
            <div className="luxury-card" style={{ padding: '50px', borderRadius: '20px', marginBottom: '50px' }}>
              <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '32px', color: '#d4af37', marginBottom: '30px', fontWeight: 700 }}>
                Programme
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
                {section1Data.program.map((item, i) => (
                  <div key={i} style={{ display: 'flex', gap: '20px', alignItems: 'center', padding: '20px', background: 'rgba(212, 175, 55, 0.05)', borderRadius: '10px' }}>
                    <span style={{ fontSize: '32px' }}>{item.icon}</span>
                    <div style={{ flex: 1 }}>
                      <p style={{ color: '#d4af37', fontWeight: 700, fontSize: '18px', marginBottom: '5px' }}>{item.time}</p>
                      <p style={{ color: '#bbb', fontSize: '16px' }}>{item.step}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
              <div className="luxury-card hover-gold" style={{ padding: '40px', borderRadius: '20px' }}>
                <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '28px', color: '#d4af37', marginBottom: '25px' }}>
                  Inclus
                </h3>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {section1Data.includes.map((item, i) => (
                    <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px', fontSize: '17px', color: '#bbb' }}>
                      <Check size={20} color="#d4af37" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="luxury-card hover-gold" style={{ padding: '40px', borderRadius: '20px' }}>
                <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '28px', color: '#d4af37', marginBottom: '25px' }}>
                  À Apporter
                </h3>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {section1Data.equipment.map((item, i) => (
                    <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px', fontSize: '17px', color: '#bbb' }}>
                      <Check size={20} color="#d4af37" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
      )}

      {currentSection === 2 && (
        <section style={{ padding: '80px 30px', background: '#0f0f0f' }} className="fade-in">
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <p style={{ fontSize: '20px', lineHeight: '1.8', color: '#ccc', marginBottom: '50px', textAlign: 'center' }}>
              {section2Data.description}
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '50px' }}>
              {Object.entries(section2Data.info).map(([key, value]) => (
                <div key={key} className="luxury-card hover-gold" style={{ padding: '25px', borderRadius: '15px', textAlign: 'center' }}>
                  <h4 style={{ color: '#d4af37', fontSize: '14px', marginBottom: '10px', textTransform: 'uppercase' }}>{key}</h4>
                  <p style={{ color: '#fff', fontSize: '16px', fontWeight: 600 }}>{value}</p>
                </div>
              ))}
            </div>
            <div className="luxury-card" style={{ padding: '50px', borderRadius: '20px', marginBottom: '50px' }}>
              <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '32px', color: '#d4af37', marginBottom: '40px', fontWeight: 700, textAlign: 'center' }}>
                Programme
              </h3>
              <div>
                {section2Data.sites.map((site, i) => (
                  <div key={i} style={{ display: 'flex', gap: '20px', alignItems: 'center', padding: '20px', background: 'rgba(212, 175, 55, 0.05)', borderRadius: '10px', marginBottom: i < section2Data.sites.length - 1 ? '40px' : '0' }}>
                    <div style={{ display: 'flex' }}>
                      <p style={{  background: 'linear-gradient(135deg, #d4af37, #f9e79f)', color: '#000',
                      padding: '15px 35px' , borderRadius: '10px', minWidth: '100px',
                      textAlign: 'center', fontWeight: 700, fontSize: '14px'}}>{site.time}</p>
                      <p style={{ color: '#bbb',marginLeft:'30px', fontSize: '16px' }}>{site.name}</p>
                    </div>
                    
                    
                    {/* <div style={{
                      background: 'linear-gradient(135deg, #d4af37, #f9e79f)', color: '#000',
                      padding: '15px 20px', borderRadius: '10px', minWidth: '100px',
                      textAlign: 'center', fontWeight: 700, fontSize: '14px'
                    }}>
                      {site.time}
                    </div>
                    <div style={{ flex: 1, paddingBottom: '20px', borderBottom: i < section2Data.sites.length - 1 ? '2px dashed rgba(212, 175, 55, 0.2)' : 'none' }}>
                      <h4 style={{ color: '#d4af37', fontSize: '22px', marginBottom: '10px', fontWeight: 700 }}>{site.name}</h4>
                    </div> */}
                  </div>
                ))}
              </div>
            </div>
            <div className="luxury-card hover-gold" style={{ padding: '50px', borderRadius: '20px' }}>
              <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '28px', color: '#d4af37', marginBottom: '30px', textAlign: 'center' }}>
                Inclus dans le tarif
              </h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
                {section2Data.services.map((service, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '15px', background: 'rgba(212, 175, 55, 0.05)', borderRadius: '10px' }}>
                    <Check size={22} color="#d4af37" />
                    <p style={{ color: '#bbb', fontSize: '16px' }}>{service}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {currentSection === 3 && (
        <section style={{ padding: '80px 30px', background: '#0f0f0f' }} className="fade-in">
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <p style={{ fontSize: '24px', lineHeight: '1.6', color: '#d4af37', marginBottom: '60px', textAlign: 'center', fontWeight: 600 }}>
              {section3Data.tagline}
            </p>
             <p style={{ fontSize: '20px', lineHeight: '1.8', color: '#ccc', marginBottom: '50px', textAlign: 'center' }}>
              {section3Data.description}
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '40px', marginBottom: '60px' }}>
              {section3Data.circuits.map((circuit, i) => (
                <div key={i} className="luxury-card hover-gold" style={{ padding: '40px', borderRadius: '20px' }}>
                  <div style={{ 
                    background: 'linear-gradient(135deg, #d4af37, #f9e79f)', color: '#000',
                    padding: '10px 20px', borderRadius: '30px', display: 'inline-block',
                    fontSize: '14px', fontWeight: 700, marginBottom: '20px'
                  }}>
                    {circuit.duration}
                  </div>
                  <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '28px', color: '#d4af37', marginBottom: '20px', fontWeight: 700 }}>
                    {circuit.title}
                  </h3>
                 
                  <div style={{ marginBottom: '25px' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                      {circuit.destinations.map((dest, j) => (
                        <span key={j} style={{ 
                          background: 'rgba(212, 175, 55, 0.1)', color: '#d4af37',
                          padding: '8px 15px', borderRadius: '20px', fontSize: '14px',
                          border: '1px solid rgba(212, 175, 55, 0.3)'
                        }}>
                          {dest}
                        </span>
                      ))}
                    </div>
                  </div>
                  <ul style={{ listStyle: 'none', padding: 0, marginBottom: '20px' }}>
                    {circuit.highlights.map((highlight, j) => (
                      <li key={j} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px', color: '#bbb', fontSize: '15px' }}>
                        <Star size={16} color="#d4af37" fill="#d4af37" />
                        {highlight}
                      </li>
                    ))}
                  </ul>
                  <p style={{ color: '#f9e79f', fontSize: '20px', fontWeight: 700 }}>{circuit.price}</p>
                </div>
              ))}
            </div>
            <div className="luxury-card" style={{ padding: '50px', borderRadius: '20px' }}>
              <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '32px', color: '#d4af37', marginBottom: '40px', fontWeight: 700, textAlign: 'center' }}>
                Expériences
              </h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '30px' }}>
                {section3Data.experiences.map((exp, i) => (
                  <div key={i} style={{ textAlign: 'center', padding: '20px' }}>
                    <div style={{ fontSize: '48px', marginBottom: '15px' }}>{exp.icon}</div>
                    <h4 style={{ color: '#d4af37', fontSize: '18px', fontWeight: 700 }}>{exp.name}</h4>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {currentSection === 4 && (
        <section style={{ padding: '80px 30px', background: '#0f0f0f' }} className="fade-in">
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <p style={{ fontSize: '22px', lineHeight: '1.6', color: '#ccc', marginBottom: '60px', textAlign: 'center' }}>
              {section4Data.slogan}
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '20px', marginBottom: '50px' }}>
              {Object.entries(section4Data.details4).map(([key, value]) => (
                <div key={key} className="luxury-card hover-gold" style={{ padding: '25px', borderRadius: '15px', textAlign: 'center' }}>
                  <h4 style={{ color: '#d4af37', fontSize: '14px', marginBottom: '10px', textTransform: 'uppercase' }}>
                    sens 
                  </h4>
                  <p style={{ color: '#fff', fontSize: '20px', fontWeight: 700 }}>{value}</p>
                </div>
              ))}
            </div>
            <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '32px', color: '#d4af37', marginBottom: '40px', fontWeight: 700, textAlign: 'center' }}>
                Aéroports desservis 
              </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '40px', marginBottom: '60px' }}>
              {section4Data.routes.map((route, i) => (
                <div key={i} className="luxury-card hover-gold" style={{ padding: '40px', borderRadius: '20px', textAlign: 'center' }}>
                  <h3 style={{ color: '#d4af37', fontSize: '24px', marginBottom: '20px', fontWeight: 700 }}>{route.from}</h3>
                  <div style={{ fontSize: '40px', margin: '20px 0' }}>✈️</div>
                  <p style={{ color: '#bbb', fontSize: '18px', marginBottom: '10px' }}>Durée: {route.duration}</p>
                  <p style={{ color: '#888', fontSize: '16px' }}>Distance: {route.distance}</p>
                </div>
              ))}
            </div>
            <div className="luxury-card" style={{ padding: '50px', borderRadius: '20px' }}>
              <h3 style={{ fontFamily: 'Playfair Display, serif', fontSize: '32px', color: '#d4af37', marginBottom: '40px', fontWeight: 700, textAlign: 'center' }}>
                Ce que nous offrons
              </h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '30px' }}>
                {section4Data.advantages.map((adv, i) => (
                  <div key={i} style={{ textAlign: 'center', padding: '20px' }}>
                    <div style={{ fontSize: '48px', marginBottom: '15px' }}>{adv.icon}</div>
                    <h4 style={{ color: '#d4af37', fontSize: '18px', fontWeight: 700 }}>{adv.title}</h4>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}
      
      <section style={{ paddingTop: '100px', padding: '100px 30px 40px', background: '#0f0f0f' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '36px', color: '#d4af37', marginBottom: '40px', fontWeight: 700 }}>
            Nos Excursions & Services
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
            {[
              { num: 1, title: 'Randonnée Vallée', icon: '⛰️' },
              { num: 2, title: 'Rochers Peints', icon: '🎨' },
              { num: 3, title: 'Désert & Dunes', icon: '🏜️' },
              { num: 4, title: 'Navette Aéroport', icon: '✈️' }
            ].map(section => (
              <button
                key={section.num}
                onClick={() => setCurrentSection(section.num)}
                style={{
                  background: currentSection === section.num ? 'linear-gradient(135deg, #d4af37, #f9e79f)' : 'transparent',
                  border: '2px solid #d4af37',
                  color: currentSection === section.num ? '#000' : '#d4af37',
                  padding: '20px', borderRadius: '15px', cursor: 'pointer',
                  fontSize: '16px', fontWeight: 600, transition: 'all 0.3s',
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px'
                }}
              >
                <span style={{ fontSize: '32px' }}>{section.icon}</span>
                <span>{section.title}</span>
              </button>
            ))}
          </div>
        </div>
      </section>
      <footer style={{ padding: '60px 30px', background: '#000', textAlign: 'center', borderTop: '1px solid rgba(212, 175, 55, 0.2)' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontFamily: 'Playfair Display, serif', fontSize: '32px', color: '#d4af37', marginBottom: '20px', fontWeight: 700 }}>
            RIAD LINA
          </h2>
          <p style={{ color: '#888', fontSize: '16px', marginBottom: '10px' }}>Tafraoute, Maroc</p>
          <p style={{ color: '#666', fontSize: '14px' }}>© 2025 Riad Lina - Tous droits réservés</p>
        </div>
      </footer>
    </div>
  );
};

export default ExcursionDetail;